import CategoriesList from './CategoriesList';

function Categories() {
  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-12 text-center">
          <div className="categories_title pb-3">
            <h3 className="fw-bold">POPULAR CATEGORIES</h3>
            <hr className="featured_underline mb-3" />
          </div>
        </div>
      </div>
      <div className="ps-1 mx-1 overflow-hidden">
        <CategoriesList />
      </div>
    </div>
  );
}

export default Categories;
